import { render, staticRenderFns } from "./roleGrant.vue?vue&type=template&id=49d5cb3a&scoped=true&"
import script from "./roleGrant.vue?vue&type=script&lang=js&"
export * from "./roleGrant.vue?vue&type=script&lang=js&"
import style0 from "./roleGrant.vue?vue&type=style&index=0&id=49d5cb3a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d5cb3a",
  null
  
)

export default component.exports